// Update Lookbook Order
export const UPDATE_LOOKBOOK_ORDER_REQUEST = 'UPDATE_LOOKBOOK_ORDER_REQUEST';
export const UPDATE_LOOKBOOK_ORDER_DONE = 'UPDATE_LOOKBOOK_ORDER_DONE';
export const UPDATE_LOOKBOOK_ORDER_FAILED = 'UPDATE_LOOKBOOK_ORDER_FAILED';
export const UPDATE_LOOKBOOK_ORDER_CLEAR_ERRORS = 'UPDATE_LOOKBOOK_ORDER_CLEAR_ERRORS';
export const UPDATE_LOOKBOOK_ORDER_RESET = 'UPDATE_LOOKBOOK_ORDER_RESET';